import React from 'react';
import styled, { css } from 'styled-components';

import { BannersSliderPrimary } from '@/components/LandingWidgets';
import { media } from '@/utils/mixin';
import { useSollersHomeData } from '@/modules/SollersHome/hooks';

function HeroSlider() {
  const { heroBanners } = useSollersHomeData();

  if (!heroBanners || heroBanners.length === 0) {
    return null;
  }

  return (
    <Component>
      <BannersSliderPrimary
        id={1}
        banners={heroBanners.map(({ image, mobileImage, text, url }) => ({
          image,
          mobileImage,
          text: text ?? '',
          url: url ?? '',
        }))}
      />
    </Component>
  );
}

export default HeroSlider;

const Component = styled.section`
  padding-bottom: 30px;

  ${media.tablet(css`
    padding-bottom: 20px;
  `)}
`;
